import React from 'react';
import { useLocation, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import brandsData from '../data/brands.json';
import perfumeriesData from '../data/perfumeries.json';
import newsData from '../data/news.json';

const Breadcrumbs = ({ bg }) => {
  const location = useLocation();
  const { t } = useTranslation();
  const newsArray = Object.values(newsData);
  // Split the pathname and filter out the locale part
  const pathnames = location.pathname
    .split('/')
    .filter((x) => x && !['en', 'me'].includes(x));

  const formatCrumb = (pathname, index) => {
    const previous = pathnames[index - 1];
    if (previous === 'brands' || previous === 'brendovi') {
      return brandsData[pathname]?.title || brandsData[pathname]?.name || pathname.replace(/-/g, ' ');
    }
    if (previous === 'perfumeries' || previous === 'parfimerije') {
      return perfumeriesData[pathname]?.title || perfumeriesData[pathname]?.name || pathname.replace(/-/g, ' ');
    }
    if (previous === 'news' || previous === 'vijesti') {
      const matchedNews =
        newsArray.find((news) => news.path === pathname || news.me_path === pathname) ||
        null;
      return matchedNews?.title ? t(matchedNews.title) : pathname.replace(/-/g, ' ');
    }

    const labelMap = {
      news: t('header.press.pageTitle'),
      vijesti: t('header.press.pageTitle'),
      perfumeries: t('header.locations.menuTitle'),
      parfimerije: t('header.locations.menuTitle'),
      brands: t('header.brands.menuTitle'),
      brendovi: t('header.brands.menuTitle'),
      products: t('header.products.menuTitle'),
      proizvodi: t('header.products.menuTitle'),
      contact: t('header.contact.menuTitle'),
      kontakt: t('header.contact.menuTitle'),
      gallery: t('header.gallery.menuTitle'),
      galerija: t('header.gallery.menuTitle'),
      'our-story': t('header.story.menuTitle'),
      'o-nama': t('header.story.menuTitle'),
      'privacy-policy': t('footer.footerMain.privacyPolicy'),
      'politika-privatnosti': t('footer.footerMain.privacyPolicy'),
      'terms-of-use': t('footer.footerMain.generalTerms'),
      'opsti-uslovi-kupovine': t('footer.footerMain.generalTerms'),
    };

    return labelMap[pathname] || pathname.replace(/-/g, ' ');
  };

  return (
    <div className={`${bg === 'light' ? 'gray-bg4' : 'lion-bg'} py-4`}>
      {pathnames.length > 0 && (
        <nav className='container'>
          <ul className={`${bg === 'light' ? 'breadcrumbs-list-light' : 'breadcrumbs-list'} breadcrumbs-flex gap-3`}>
            <li>
              <Link to={`/${location.pathname.split('/')[1]}`}><i className='fa-solid fa-house'></i></Link>
            </li>
            {pathnames.map((pathname, index) => {
              const route = `/${location.pathname.split('/')[1]}/${pathnames.slice(0, index + 1).join('/')}`;
              const isLast = index === pathnames.length - 1;

              return (
                <React.Fragment key={route}>
                  <li>
                    <i className='fa-solid fa-chevron-right breadcrumbs-separator'></i>
                  </li>
                  <li>
                    {isLast ? (
                      <span className='breadcrumbs-active'>
                        {formatCrumb(pathname, index)}
                      </span>
                    ) : (
                      <Link to={route}>
                        {formatCrumb(pathname, index)}
                      </Link>
                    )}
                  </li>
                </React.Fragment>
              );
            })}
          </ul>
        </nav>
      )}
    </div>
  );
};

export default Breadcrumbs;
